var redefine = require('./$.redefine');
module.exports = function(target, src){
  for(var key in src)redefine(target, key, src[key]);
  return target;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.redefine-all.js
 ** module id = 144
 ** module chunks = 0
 **/